// removed by extract-text-webpack-plugin
module.exports = {"container":"_3u8xWKFqyBP-IyNVhhlqUx","toaster":"_3ZO9z6aVZ5lDH4rYhF28_y"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/AppRoot/styles.scss
// module id = 647
// module chunks = 11